/* ==================== CONFIG ==================== */
// Variantes que disparan el regalo
const TRIGGER_VARIANT_IDS = [
  47205265932503,
  47205265965271,
  47205265998039,
  47254574235863,
  47254574301399
];

// ¿Un regalo por cada unidad del disparador? true = sí; false = máximo 1 por pedido
const MATCH_TRIGGER_QUANTITY = true;

// Colección (handle) con las opciones de regalo
const GIFT_COLLECTION_HANDLE = 'regalos-gwp';

// Propiedades para identificar líneas de regalo
const GIFT_PROP_KEY = '_regalo';
const GIFT_PROP_VAL = 'true';
/* ================================================ */

/* ====== Referencias del modal (asegúrate de tener el HTML) ====== */
const modal = document.getElementById('gwp-modal');
const grid = document.getElementById('gwp-grid');
const btnDone = document.getElementById('gwp-done');
const btnClose = modal?.querySelector('.gwp-close');
const subtitle = modal?.querySelector('.gwp-subtitle');

/* ====== Estado ====== */
let giftsCatalog = [];      // [{ product, variant }]
let selections = new Map(); // variantId -> qty (1 por tarjeta)
let requiredGifts = 0;

/* ====== Utilidades de carrito ====== */
async function getCart() {
  const r = await fetch('/cart.js', { credentials: 'same-origin' });
  if (!r.ok) throw new Error('No se pudo leer el carrito');
  return r.json();
}
async function addToCart(variantId, qty, properties = {}) {
  const r = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties }] })
  });
  if (!r.ok) throw new Error('No se pudo agregar al carrito');
  return r.json();
}
async function updateCart(updates) {
  const r = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ updates })
  });
  if (!r.ok) throw new Error('No se pudo actualizar el carrito');
  return r.json();
}
function analyzeCart(cart) {
  let triggerQty = 0;
  let giftLines = [];
  cart.items.forEach(item => {
    if (TRIGGER_VARIANT_IDS.includes(item.id)) triggerQty += item.quantity;
    const isGift = item.properties && item.properties[GIFT_PROP_KEY] === GIFT_PROP_VAL;
    if (isGift) giftLines.push({ variantId: item.id, qty: item.quantity, key: item.key });
  });
  return { triggerQty, giftLines };
}

/* ====== Refrescar Drawer (Trade) sin recargar ====== */
async function refreshCartDrawer() {
  const drawerEl = document.querySelector('cart-drawer');
  if (!drawerEl || typeof drawerEl.renderContents !== 'function') return;

  const sectionsToFetch = ['cart-drawer', 'cart-icon-bubble'];
  const res = await fetch(`/?sections=${sectionsToFetch.join(',')}`, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });
  if (!res.ok) return;

  const sectionsHtml = await res.json();

  // Lo que CartDrawer.renderContents espera
  const parsedState = {
    sections: sectionsHtml
    // id: opcional (podrías pasar el variantId agregado más reciente si quieres)
  };

  drawerEl.renderContents(parsedState); // Reinyecta HTML y abre el drawer
}

/* ====== Modal / UI ====== */
function openModal() { if (modal) modal.classList.remove('hidden'); }
function closeModal() { if (modal) { modal.classList.add('hidden'); selections.clear(); updateDoneState(); } }
function setRemaining(n) { if (subtitle) subtitle.textContent = `Selecciona ${n} regalo(s) disponible(s).`; }
function updateDoneState() {
  const selectedCount = Array.from(selections.values()).reduce((a,b)=>a+b,0);
  if (btnDone) btnDone.disabled = (selectedCount !== requiredGifts);
}

async function loadGifts() {
  const res = await fetch(`/collections/${GIFT_COLLECTION_HANDLE}/products.json?limit=50`, { credentials: 'same-origin' });
  if (!res.ok) { giftsCatalog = []; return; }
  const data = await res.json();
  giftsCatalog = (data.products || [])
    .map(p => {
      const available = (p.variants || []).find(v => v.available);
      return available ? { product: p, variant: available } : null;
    })
    .filter(Boolean);
}

function renderGifts() {
  if (!grid) return;
  grid.innerHTML = '';
  giftsCatalog.forEach(({ product, variant }) => {
    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'gwp-card';
    card.dataset.variantId = variant.id;

    const img = document.createElement('img');
    img.src = product.images?.[0]?.src || '//cdn.shopify.com/s/images/admin/no-image-large.gif';
    img.alt = product.title;

    const title = document.createElement('div');
    title.textContent = product.title;

    const price = document.createElement('div');
    price.className = 'gwp-price';
    price.textContent = 'Gratis';

    card.append(img, title, price);
    card.addEventListener('click', () => {
  const already = selections.get(variant.id) || 0;
  if (already) {
    selections.delete(variant.id);
    card.classList.remove('selected');
  } else {
    const selectedIds = Array.from(selections.keys());

    if (requiredGifts === 1 && selectedIds.length === 1) {
      // Desmarca el que estaba y marca el nuevo (swap)
      const prevId = selectedIds[0];
      selections.delete(prevId);
      const prevCard = grid.querySelector(`[data-variant-id="${prevId}"]`);
      prevCard?.classList.remove('selected');

      selections.set(variant.id, 1);
      card.classList.add('selected');
    } else if (selectedIds.length < requiredGifts) {
      selections.set(variant.id, 1);
      card.classList.add('selected');
    }
  }
  updateDoneState();
});


    grid.appendChild(card);
  });
}

/* ====== Lógica principal de sincronización ====== */
async function ensureGiftsSynced(showChooserIfNeeded = true) {
  const cart = await getCart();
  const { triggerQty, giftLines } = analyzeCart(cart);
  const desired = triggerQty === 0 ? 0 : (MATCH_TRIGGER_QUANTITY ? triggerQty : 1);

  // Sin disparador → eliminar regalos
  if (desired === 0 && giftLines.length) {
    const updates = {};
    giftLines.forEach(gl => { updates[gl.variantId] = 0; });
    await updateCart(updates);
    return;
  }

  if (desired > 0) {
    const currentGiftCount = giftLines.reduce((a,b)=>a+b.qty, 0);

    // Faltan regalos → abrir selector
    if (currentGiftCount < desired && showChooserIfNeeded) {
      requiredGifts = desired - currentGiftCount;
      await loadGifts();
      renderGifts();
      setRemaining(requiredGifts);
      openModal();
      return; // esperar selección
    }

    // Sobran regalos → recortar
    if (currentGiftCount > desired) {
      let toRemove = currentGiftCount - desired;
      const updates = {};
      for (const gl of giftLines) {
        const removeQty = Math.min(gl.qty, toRemove);
        updates[gl.variantId] = gl.qty - removeQty; // puede ser 0
        toRemove -= removeQty;
        if (toRemove === 0) break;
      }
      await updateCart(updates);
    }
  }
}

/* ====== Botón "Listo" ====== */
btnDone?.addEventListener('click', async () => {
  btnDone.disabled = true;
  try {
    // Agrega las selecciones como regalo
    for (const [variantId, qty] of selections.entries()) {
      await addToCart(Number(variantId), qty, { [GIFT_PROP_KEY]: GIFT_PROP_VAL });
    }

    closeModal();

    // Re-sincroniza por límites/cambios y refresca drawer sin recargar
    await ensureGiftsSynced(false);
    await refreshCartDrawer();

  } catch (e) {
    console.warn(e);
    btnDone.disabled = false;
  }
});

/* ====== Cerrar modal ====== */
btnClose?.addEventListener('click', () => closeModal());
modal?.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

/* ====== Hooks: add-to-cart y cambios de qty ====== */
document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if ((form.getAttribute('action') || '').includes('/cart/add')) {
    setTimeout(() => { ensureGiftsSynced(true).catch(console.warn); }, 800);
  }
});
document.addEventListener('change', (e) => {
  const el = e.target;
  if (!(el instanceof HTMLElement)) return;
  if (el.getAttribute('name')?.includes('updates')) {
    setTimeout(async () => {
      try {
        await ensureGiftsSynced(true);
        await refreshCartDrawer(); // que el drawer se vea al instante
      } catch (err) { console.warn(err); }
    }, 800);
  }
});

/* ====== Inicial ====== */
document.addEventListener('DOMContentLoaded', () => {
  ensureGiftsSynced(true).catch(console.warn);
});

/* ====== API pública (opcional): "Cambiar regalo" ====== */
window.openGiftChooser = async function () {
  await ensureGiftsSynced(true);
  await loadGifts();
  renderGifts();
  const cart = await getCart();
  const { triggerQty } = analyzeCart(cart);
  requiredGifts = (triggerQty === 0) ? 1 : (MATCH_TRIGGER_QUANTITY ? triggerQty : 1);
  setRemaining(requiredGifts);
  openModal();
};
